import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './styles/CartError.scss';

export default function CartError() {
    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <FormattedMessage
                    id="CartError.header"
                    defaultMessage="Sorry, an error has occurred."
                />
            </div>
            <div className={styles.message}>
                <FormattedMessage
                    id="CartError.message"
                    defaultMessage="There was an issue loading your cart. Please try refreshing the page. If the issue persists, please {contactUs}."
                    values={{
                        contactUs: (
                            <a href="https://support.1stdibs.com/#Contact">
                                <FormattedMessage
                                    id="CartError.contactUs"
                                    defaultMessage="contact us"
                                />
                            </a>
                        ),
                    }}
                />
            </div>
        </div>
    );
}
